import React, { PureComponent } from "react";
import connect from "react-redux/es/connect/connect";
import { withRouter } from "react-router-dom";
import "./callback.css";
import queryString from "query-string";
import IconSettings from "@salesforce/design-system-react/components/icon-settings";
import Toast from "@salesforce/design-system-react/components/toast";
import ToastContainer from "@salesforce/design-system-react/components/toast/container";
import {
    isEmpty,
    doLogout,
    getApiBaseURL,
    handleAPIErrors,
} from "../../common";
import Spinner from "@salesforce/design-system-react/components/spinner";
import { PU_RELEATIVE_PATH, SF_ICON_PATH } from "../../../config";
import api from "../../../api";

class CallbackWithAutoRegistration extends PureComponent<{}, any> {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            toastHeaderInfo: null,
            showToast: false,
        };
    }
    async componentDidMount() {
        try {
            this.getInitData();
        } catch (e) {
            console.log("some error", e, e.message);
        }
    }

    //Using Auth Code authenticate the connected app to get access token.
    validateAuthCodeandRegisterOrg(authCode, isSandbox) {
        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
        };

        if (isSandbox)
            requestOptions.headers = {
                "Content-Type": "application/json",
                OrgType: "sandbox",
            };

        api.post(getApiBaseURL() + "/Login/AutoRegisterOrg", JSON.stringify(authCode), requestOptions)
            .then((response) => response.data)
            .then((response) => {
                this.setState({ isLoading: false });
                this.openToast("The Org has been succesfully registered with Conga Upgrade. Thank you.")
            });
    }

    //Redirect to registration form page by passing the Organization ID.
    redirectToRegistrationPageWithOrgId() {
        window.location.href = PU_RELEATIVE_PATH + "consent-form";
    }

    openToast(message) {
        this.setState({ toastHeaderInfo: message });
        this.setState({ showToast: true });
    }



    redirectToSFLogin(isSandbox) {
        this.setState({ isLoading: true });
        doLogout();
        const requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        };

        if (isSandbox) {
            requestOptions.headers = {
                "Content-Type": "application/json",
                OrgType: "sandbox",
            };
        }
        api.get(getApiBaseURL() + "/Login/GetSFDCLoginUrlWithAutoRegistration", requestOptions)
            .then((response) => response.data)
            .then((redirectURL) => {
                var urlParams = redirectURL.substring(redirectURL.indexOf("?") + 1);
                var paramArray = urlParams.split("&");
                paramArray.forEach((element) => {
                    if (element.indexOf("state") >= 0) {
                        var stateId = element.split("=")[1];
                        sessionStorage.setItem("state", stateId);
                    }
                });
                this.setState({ isLoading: false });
                window.location.assign(redirectURL);
            });
    }

    getInitData = async () => {
        let checkParams = queryString.parse(this.props.location.search);
        let type = this.props.match.params.type;
        let authcode = checkParams?.code;
        let state = checkParams?.state;
        let loginToSandBox = false;
        this.setState({ isLoading: true });

        // Get error msg from Salesforce CallBack URL
        this.error = checkParams?.error;
        this.error_description = checkParams.error_description;
        // If it is present then alert and clear  access token
        if (!isEmpty(this.error)) {
            doLogout();
            window.location.href =
                window.location.origin +
                "/registration/ui/forbidden?error=" +
                this.error +
                "&error_description=" +
                this.error_description;
        }

        // Check if the login Type is not empty and set the sandbox login flag.
        if (!isEmpty(type) && type.toLowerCase() === "sandbox") {
            loginToSandBox = true;
        }

        if (!isEmpty(authcode)) {
            if (state === sessionStorage.getItem("state")) {
                sessionStorage.removeItem("state");
                this.validateAuthCodeandRegisterOrg(authcode, loginToSandBox);
            } else {
                console.log("Invalid State");
                doLogout();
                window.location.href = PU_RELEATIVE_PATH + "welcome";
            }
        }
        else {
            this.redirectToSFLogin(loginToSandBox)
        }
    };

    render() {
        return (
            <div class="callback-background-theme">
                {this.state.isLoading && (
                    <Spinner
                        size="large"
                        variant="brand"
                        assistiveText={{ label: "Loading..." }}
                    />
                )}

                <IconSettings iconPath={SF_ICON_PATH}>
                    {this.state.showToast && (
                        <ToastContainer>
                            <Toast
                                labels={{
                                    heading: [this.state.toastHeaderInfo],
                                }}
                                variant="success"
                                duration="5000"
                                onRequestClose={() => {
                                    this.setState({ showToast: false });
                                }}
                            />
                        </ToastContainer>
                    )}
                </IconSettings>
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {};
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {};
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(CallbackWithAutoRegistration));
